@if (shouldShowSearchPopup) {
  <kt-new-popup (onClose)="close()">
    @if (isChartRendering) {
      <div
        [ngClass]="{
          'kt-spinner kt-spinner--input kt-spinner--lg kt-spinner--brand kt-spinner--center d-flex':
            isChartRendering,
        }"
        style="height: 60px"
        body
      ></div>
    }
    <div header class="header-main d-flex flex-column">
      <span class="header-message">{{ title }}</span>
      <span class="pt-1"
        ><span
          caiPopover
          [enablePopover]="campaignId === userAds.QUALITYSCORE"
          [target]="tooltip"
          [allowHoverOnTarget]="true"
          [zIndex]="1200"
          [placement]="'right-start'"
          >{{ subTitle }}</span
        ></span
      >
      <ng-template #tooltip>
        <kt-popover
          [arrowColor]="'#679EC6'"
          [bgColor]="'#679EC6'"
          [textColor]="'white'"
          [placement]="'right-start'"
          style="max-width: 255px !important"
        >
          <span body i18n="@@search-popup.quality-score-tooltip"
            >Quality Scores are calculated with at least 5 shipments over a
            period of 90 days. More information
            <a
              href="https://help.cargoai.co/en/articles/7439184-cargoquality-your-guide-to-selecting-the-best-airlines-on-cargomart"
              target="_blank"
              rel="noopener"
              >here:
            </a></span
          >
        </kt-popover>
      </ng-template>
    </div>
    <div footer class="search-popup__footer pb-2">
      <span i18n="@@global.close" class="close-button" (click)="close()"
        >Close</span
      >
    </div>
    @if (
      adConfig?.configurations?.legends && campaignId !== userAds.QUALITYSCORE
    ) {
      <div
        class="legend"
        legend
        [class.co2-legend]="campaignId === userAds.CO2"
      >
        <div class="legend-wrapper">
          <div
            class="legend-symbol"
            [ngStyle]="{
              background:
                campaignId === userAds.CO2
                  ? '#aac6f4'
                  : campaignId === userAds.RATE
                    ? '#c261f9'
                    : '#8D3E7C',
            }"
          ></div>
          <span class="label">{{
            adConfig?.configurations?.legends?.[0]
          }}</span>
        </div>
        <div class="legend-wrapper">
          <div
            class="legend-symbol"
            [ngStyle]="{
              background:
                campaignId === userAds.CO2
                  ? '#5085d9'
                  : campaignId === userAds.RATE
                    ? '#5ea8d8'
                    : '#F45814',
            }"
          ></div>
          <span>{{ adConfig?.configurations?.legends?.[1] }}</span>
        </div>
        @if (campaignId === userAds.CAPACITY) {
          <div class="legend-wrapper" style="margin-left: 10px">
            <div
              class="legend-symbol"
              [ngStyle]="{
                background: '#7CA4D0',
              }"
            ></div>
            <span>{{ adConfig?.configurations?.legends?.[2] }}</span>
          </div>
        }
      </div>
    }
    @if (
      adConfig?.configurations?.legends && campaignId === userAds.QUALITYSCORE
    ) {
      <div
        class="legend"
        legend
        [class.co2-legend]="campaignId === userAds.QUALITYSCORE"
      >
        <div class="legend-wrapper">
          <div
            class="legend-symbol"
            [ngStyle]="{
              background: '#5EA8D8',
            }"
          ></div>
          <span class="label">{{
            adConfig?.configurations?.legends?.[0]
          }}</span>
        </div>
        <div class="legend-wrapper">
          <div
            class="legend-symbol"
            [ngStyle]="{
              background: '#f45814',
            }"
          ></div>
          <span>{{ adConfig?.configurations?.legends?.[1] }}</span>
        </div>
      </div>
    }
    @if (isVideo) {
      <video
        id="singleVideo"
        preload="metadata"
        [autoplay]="true"
        [muted]="true"
        [loop]="true"
        controls
        body
        style="height: 432px"
      >
        <source src="/static/videos/cargoai-2023-review.mp4" type="video/mp4" />
      </video>
    }
    @if (isPromotion && !isVideo) {
      <img
        body
        [src]="adConfig?.configurations?.staticSrc"
        style="margin-bottom: 10px"
        (click)="handleImageClick()"
        alt="ads"
        width="768"
        height="420"
        [class.default-cursor]="!adConfig?.configurations?.href"
        [ngStyle]="{
          cursor: !adConfig?.configurations?.href ? 'default' : 'pointer',
        }"
      />
    }
    @if (!isPromotion) {
      <div
        echarts
        body
        [options]="chartOption"
        class="demo-chart"
        [class.co2-chart]="campaignId === userAds.CO2"
        style="width: 100%"
        chart
        (chartInit)="onChartInit()"
      ></div>
    }
  </kt-new-popup>
}
